import React from 'react';
import AdminWordlistDetailContainer from '../components/adminWordlistDetail.container';

/** `/admin/wordlists/:wordlistId` — one list's detail, edit and delete/restore. */
const AdminWordlistDetailPage: React.FC = () => <AdminWordlistDetailContainer />;

export default AdminWordlistDetailPage;
